/*
 * Module for the irs 1099r transmit file job criteria page
 */
rs.module("content/jobs/criteria/irs1099rtransmitterfile",

    ["common/select-helper"],

    function (selectHelper) {
        // Initialize the page
        function initialize(jsSelectors, ajaxUrl, recreateOption, fundKey) {
            var criteria = $.js(jsSelectors.criteria);
            var fileTypeSelect = criteria.js(jsSelectors.fileTypeSelect);
            var fileCreationDateSelect = criteria.js(jsSelectors.fileCreationDateSelect);
            var fileCreationDateSelectHelper = selectHelper.getHelper(fileCreationDateSelect);
            var taxYearSelect = criteria.js(jsSelectors.taxYearSelect);
            var fileStatusSelect = criteria.js(jsSelectors.fileStatusSelect);

            fileTypeSelect.change(setAvailableCreationDates);
            fileStatusSelect.change(setAvailableCreationDates);
            taxYearSelect.change(setAvailableCreationDates);

            function setAvailableCreationDates() {
                fileCreationDateSelectHelper.setDisabled(fileTypeSelect.val() != recreateOption);
                if (fileTypeSelect.val() == recreateOption) {
                    fileCreationDateSelectHelper.loadOptionsFrom(
                        ajaxUrl,
                        {
                            fundKey: fundKey,
                            taxYear: taxYearSelect.val(),
                            transmitStatus: fileStatusSelect.val()
                        },
                        {
                            withBlank: false
                        });
                } else {
                    fileCreationDateSelectHelper.clearOptions();
                    fileCreationDateSelect.clearErrors();
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);